import { No as NoIcon, Search as SearchIcon } from '@velocity-exchange/icons';
import React from 'react';
import { cj, cm } from 'src/utils/classNames';
import { BaseTextInputProps } from 'src/components/primitives/Input/types';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import Input from 'src/components/primitives/Input/Input';

interface Props extends Omit<
	BaseTextInputProps,
	'prefix' | 'suffix' | 'type' | 'value' | 'onChange'
> {
	id: string;
	size?: 'sm' | 'md';
	query?: string;
	setQuery?: (query: string) => void;
	dataTestId?: string;
}

export default function SearchBar({
	id,
	size,
	query,
	setQuery,
	dataTestId,
	...rest
}: Props) {
	return (
		<Input
			id={id}
			type="text"
			size={size}
			labelVariant="inset"
			dataTestId={dataTestId}
			label={
				<>
					<SearchIcon size={size === 'sm' ? 16 : 20} />
					<span className="sr-only">Search</span>
				</>
			}
			labelClassName={cj(
				'flex transition-colors',
				query && 'text-text-default',
				size === 'sm' ? 'pr-xs' : 'pr-sm'
			)}
			inputClassName="text-left pl-0"
			// Clear input button.
			suffix={
				<IconButton
					size={size === 'sm' ? 'sm' : 'lg'}
					variant="tertiary"
					icon={NoIcon}
					onClick={() => setQuery?.('')}
				/>
			}
			suffixClassName={cm(
				'pointer-events-none flex opacity-0 transition-opacity',
				query && 'pointer-events-auto opacity-100',
				rest.disabled && 'cursor-not-allowed'
			)}
			value={query}
			onChange={setQuery}
			{...rest}
		/>
	);
}
